module.exports = __webpack_public_path__ + "static/media/logo-instagram.a5270aa8.svg";